import { render, staticRenderFns } from "./controle-limites.vue?vue&type=template&id=f056fd22&scoped=true&"
import script from "./controle-limites.vue?vue&type=script&lang=js&"
export * from "./controle-limites.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=f056fd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f056fd22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
